import { J2Add } from '@e3dc-react/icons'
import { IconButton, SxProps } from '@mui/material'
import React from 'react'
import useModals from 'src/Hooks/useModals'
import { DownloadsParent } from '../models'

interface Props {
  parent: DownloadsParent
  isFirstLevel?: boolean
  selectCategory: (categoryId?: number) => void
  sx?: SxProps
}

const AddSubcategoryButton: React.FC<Props> = ({ parent, selectCategory, isFirstLevel, sx }) => {
  const { openDownloadCategoryEditor } = useModals()

  const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    openDownloadCategoryEditor({ parent, selectCategory, isFirstLevel })
  }

  return (
    <IconButton onClick={onClick} color="primary" sx={sx} data-qa={'iconButton-add-subcategory'}>
      <J2Add />
    </IconButton>
  )
}

export default AddSubcategoryButton
